import { z } from 'zod';
/**
 * Phase 3 (doc 11 §4) — the versioned event catalog. Each entry pairs a
 * literal `type` with its payload schema so producers validate before the
 * outbox write and consumers narrow `payload: unknown` safely.
 *
 * Schemas are `.passthrough()` on purpose: the versioning rule is additive
 * (new optional fields don't bump the version; removals/renames do).
 *
 * Keystone set only — campaign.*, subscription.* (blocked on R-01),
 * user.*, webhook.received are catalogued in doc 11 but deferred (T18).
 * NOTE on ids: WhatsAppMessageLog ids are bigint — serialized as strings
 * in payloads (JSON transport).
 */
export const eventCatalog = {
    'message.received': {
        version: 1,
        payload: z
            .object({
            messageLogId: z.string(),
            contactId: z.number().int(),
            wamid: z.string(),
            messageType: z.string(),
            body: z.string().nullable(),
            channel: z.literal('whatsapp'),
        })
            .passthrough(),
    },
    'message.sent': {
        version: 1,
        payload: z
            .object({
            wamid: z.string(),
            contactId: z.number().int().nullable(),
            channel: z.literal('whatsapp'),
            campaignId: z.number().int().nullable(),
        })
            .passthrough(),
    },
    'message.status-updated': {
        version: 1,
        payload: z
            .object({
            wamid: z.string(),
            status: z.string(),
        })
            .passthrough(),
    },
    'contact.created': {
        version: 1,
        payload: z
            .object({
            contactId: z.number().int(),
            waId: z.string().nullable(),
            source: z.string(),
        })
            .passthrough(),
    },
    'contact.updated': {
        version: 1,
        payload: z
            .object({
            contactId: z.number().int(),
            fields: z.array(z.string()),
        })
            .passthrough(),
    },
    'suppression.added': {
        version: 1,
        payload: z
            .object({
            waId: z.string(),
            source: z.string(),
        })
            .passthrough(),
    },
    'bot.flow.advanced': {
        version: 1,
        payload: z
            .object({
            contactId: z.number().int(),
            botFlowId: z.number().int(),
            toNodeId: z.string(),
        })
            .passthrough(),
    },
};
export function isKnownEventType(type) {
    return type in eventCatalog;
}
